import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2380773144/src/src/app/ui/main/need-login-box.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2380773144/src/src/app/ui/main/saved-pios-more-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2380773144/src/src/app/ui/main/saved-poi-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2380773144/src/src/app/ui/main/survey-start-bottom-button.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/svg/main/alert_gray_32_32.svg");
